import axios from 'axios';

import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

export const LoadService = async (fields, _retries = 1) => {
  let paramss = {};
  if (fields == undefined || fields == '') {
    paramss = {
      where: {
        active: true,
      },
    };
  } else {
    paramss = {
      where: {
        active: true,
      },
      keys: 'category,Price,title,image2,slug,category.slug,thumbnail,description,sub-category',
    };
  }

  try {
    const { data: data2 } = await axios.get(
      'https://24doc.b4a.io/classes/Services',
      {
        params: paramss,
        headers: {
          'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
          'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
          'X-Parse-Revocable-Session': 1,
          'Content-Type': 'application/json',
        },
      }
    );
    return data2;
  } catch (err) {
    // Retry once on 502 — commonly a stale keep-alive socket reused after B4A closed it
    if (_retries > 0 && err?.response?.status === 502) {
      return LoadService(fields, _retries - 1);
    }
    throw err;
  }
};
// Trim a Services row to the fields the listing pages (/ and /services)
// actually render, so getStaticProps doesn't serialize description/image2
// into the static page data
export const slimServiceForListing = (dis) => ({
  objectId: dis.objectId,
  title: dis.title ?? null,
  slug: dis.slug ?? null,
  Price: dis.Price ?? null,
  thumbnail: dis.thumbnail ?? null,
  category: dis.category
    ? {
        objectId: dis.category.objectId,
        slug: dis.category.slug ?? null,
      }
    : null,
});
export const LoadMedications = async (fields) => {
  let paramss = {};
  if (fields == undefined || fields == '') {
    paramss = {
      where: {
        active: true,
      },
    };
  } else {
    paramss = {
      where: {
        active: true,
        category: {
          __type: 'Pointer',
          className: 'Services_Category',
          objectId: '1LHzR8eHNc',
        },
      },
      keys: 'category,Price,title,image2,slug,category.slug,thumbnail,description,sub_category',
    };
  }

  const { data: data2 } = await axios.get(
    'https://24doc.b4a.io/classes/Services',
    {
      params: paramss,
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const LoadServiceSitemaps = async (service) => {
  const url = new URL('https://24doc.b4a.io/classes/Services');

  // Add query parameters
  const params = {
    where: JSON.stringify({ active: true }),
    keys: 'title',
  };
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
      'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
      'X-Parse-Revocable-Session': '1',
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data2 = await response.json();
  return data2;
};

export const LoadSpecificService = async (id, fields = '') => {
  const params = fields ? { keys: fields } : {};
  try {
    const { data: data2 } = await axios.get(
      `https://24doc.b4a.io/classes/Services/${id}`,
      {
        params,
        headers: {
          'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
          'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
          'X-Parse-Revocable-Session': 1,
          'Content-Type': 'application/json',
        },
      }
    );
    return data2;
  } catch (err) {
    return null;
  }
};
export const LoadSpecificServiceBySlug = async (id, fields = '') => {
  const params = fields ? { keys: fields } : {};

  const { data: data2 } = await axios.get(
    `https://24doc.b4a.io/classes/Services/`,
    {
      params: {
        where: {
          slug: id,
        },
        keys: fields || undefined,
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};

export const LoadServiceCategory = async (service) => {
  const { data: data2 } = await axios.get(
    'https://24doc.b4a.io/classes/Services_Category',
    {
      params: {
        where: {
          page: service,
        },
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const checkIfPatientEnrolledInOpenLoopCondition = async (
  patient_id,
  service_id,
  isOpenloop = true
) => {
  const { data: data2 } = await axios.get(
    ` https://24doc.b4a.io/classes/Openloop_Diagnosis`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
      params: {
        limit: 1,

        where: {
          User: {
            __type: 'Pointer',
            className: '_User',
            objectId: patient_id,
          },
          Service: {
            __type: 'Pointer',
            className: 'Services',
            objectId: service_id,
          },
          Payment: 'PAID',
        },
      },
    }
  );
  return data2;
};
export const checkIfPatientEnrolledInWeightlossProgramin6Months = async (
  patient_id,
  isOpenloop = true
) => {
  const service_ids = [
    'EPzuICJy88',
    'dDZLlErdEF',
    'pmj8BBmv1L',
    'o8NlDExkLo',
    'WOfo5j3mwb',
  ];
  const servicePointers = service_ids.map((id) => ({
    __type: 'Pointer',
    className: 'Services',
    objectId: id,
  }));

  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  const where = {
    User: { __type: 'Pointer', className: '_User', objectId: patient_id },
    Service: { $in: servicePointers },
    Payment: 'PAID',
    createdAt: { $gte: { __type: 'Date', iso: sixMonthsAgo.toISOString() } },
  };

  const { data } = await axios.get(
    `https://24doc.b4a.io/classes/${
      isOpenloop ? 'Openloop_Diagnosis' : 'Diagnosis'
    }`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
      params: {
        where: JSON.stringify(where),
        count: 1, // ask Parse to compute count
        limit: 0, // return zero objects
      },
    }
  );

  // data looks like: { results: [], count: 3 }
  return data.count ?? 0;
};
export const checkIfDiscountEligibleMicro = async (patient_id) => {
  // const service_ids = ['WOfo5j3mwb'];
  // const servicePointers = service_ids.map((id) => ({
  //   __type: 'Pointer',
  //   className: 'Services',
  //   objectId: id,
  // }));

  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  const where = {
    User: { __type: 'Pointer', className: '_User', objectId: patient_id },
    Service: {
      __type: 'Pointer',
      className: 'Services',
      objectId: 'WOfo5j3mwb',
    },
    Payment: 'PAID',
    createdAt: { $gte: { __type: 'Date', iso: sixMonthsAgo.toISOString() } },
  };

  const { data } = await axios.get(
    `https://24doc.b4a.io/classes/Openloop_Diagnosis`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
      params: {
        where: JSON.stringify(where),
        count: 1, // ask Parse to compute count
        limit: 0, // return zero objects
      },
    }
  );

  // data looks like: { results: [], count: 3 }
  return data.count > 0 ? true : false;
};
export const checkIfPreviouslyApaidPatient = async (
  patient_id,
  service_id,
  isOpenloop = true
) => {
  const { data: data2 } = await axios.get(
    ` https://24doc.b4a.io/classes/${
      isOpenloop ? 'Openloop_Diagnosis' : 'Diagnosis'
    }`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
      params: {
        limit: 1,

        where: {
          User: {
            __type: 'Pointer',
            className: '_User',
            objectId: patient_id,
          },
          Service: {
            __type: 'Pointer',
            className: 'Services',
            objectId: service_id,
          },
          isSync: true,
          Payment: 'PAID',
        },
      },
    }
  );
  return data2;
};
export const LoadSpecificServiceCategory = async (id) => {
  const { data: data2 } = await axios.get(
    `https://24doc.b4a.io/classes/Services_Category/${id}`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};

export const UpdateUser = async (userID, data) => {
  const sessionToken = Cookies.get('sessionToken');
  if (sessionToken) {
    // axios.post('/api/auth/check-token', { sessionToken });
    const { data: data2 } = await axios.put(
      `https://24doc.b4a.io/users/${userID}`,
      data,
      {
        headers: {
          'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
          'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
          'X-Parse-Session-Token': sessionToken,
          'Content-Type': 'application/json',
        },
      }
    );

    return data2;
  } else {
    return null;
  }
};

export const UpdatePassword = async (
  id,
  username,
  currentPassword,
  newPassword
) => {
  const sessionToken = Cookies.get('sessionToken');
  if (sessionToken) {
    try {
      const { data: data2 } = await axios.get(
        `https://24doc.b4a.io/verifyPassword?username=${username}&password=${currentPassword}`,
        {
          headers: {
            'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
            'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
            'Content-Type': 'application/json',
          },
        }
      );
      if (data2) {
        const data = await UpdateUser(id, { password: newPassword });

        Cookies.set('sessionToken', data.sessionToken, { expires: 360 });

        toast.success('Password Successfully Changed');

        return true;
      }
      toast.error('Current Password is Incorrect');
      return null;
    } catch (e) {
      toast.error('Current Password is Incorrect');
      return null;
    }
  } else {
    return null;
  }
};

export const VerifyEmail = async (username) => {
  try {
    const { data: data2 } = await axios.get(`https://24doc.b4a.io/users`, {
      params: {
        where: {
          username: username,
        },
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'Content-Type': 'application/json',
      },
    });
    if (data2.results[0]) {
      return data2.results[0];
    }
    return null;
  } catch (e) {
    console.log('Error in verifying email:', e);
    return null;
  }
};

export const AddDiagonsis = async (data, isOpenloop) => {
  const { data: data2 } = await axios.post(
    ` https://24doc.b4a.io/classes/${
      isOpenloop ? 'Openloop_Diagnosis' : 'Diagnosis'
    }`,
    {
      ...data,
      User: {
        __type: 'Pointer',
        className: '_User',
        objectId: data.User,
      },
      Service: {
        __type: 'Pointer',
        className: 'Services',
        objectId: data.Service,
      },
    },
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};

export const UpdateDiagonsis = async (idRef, data, idState) => {
  const sessionToken = Cookies.get('sessionToken');
  if (sessionToken) {
    try {
      const { data: data2 } = await axios.put(
        `https://api-v2.24hrdoc.com/Diagnosis/${idRef || idState}`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionToken}`, // Bearer token
            'Content-Type': 'application/json',
          },
        }
      );
      return data2;
    } catch (err) {
      console.log('Error', err);
    }
  } else {
    toast.error('You are not authorized');
  }
};
export const UpdateDiagonsisOpenloop = async (idRef, data, idState) => {
  const sessionToken = Cookies.get('sessionToken');
  if (sessionToken) {
    try {
      const { data: data2 } = await axios.put(
        `https://api-v2.24hrdoc.com/openloop-diagnosis/${idRef || idState}`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionToken}`, // Bearer token
            'Content-Type': 'application/json',
          },
        }
      );
      return data2;
    } catch (err) {
      console.log('Error', err);
    }
  } else {
    toast.error('You are not authorized');
  }
};
export const UpdateRefillStatus = async (idRef) => {
  const sessionToken = Cookies.get('sessionToken');
  if (sessionToken) {
    try {
      const { data: data2 } = await axios.put(
        `https://24doc.b4a.io/classes/Refills/${idRef}`,
        {
          has_refilled: true,
        },
        {
          headers: {
            'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
            'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
            'X-Parse-Revocable-Session': 1,
            'Content-Type': 'application/json',
          },
        }
      );
      return data2;
    } catch (err) {
      console.log('Error', err);
    }
  } else {
    toast.error('You are not authorized');
  }
};
export const UpdateDiagonsisOld = async (
  idRef,
  data,
  idState,
  isOpenloop = false
) => {
  const sessionToken = Cookies.get('sessionToken');
  if (sessionToken) {
    try {
      const { data: data2 } = await axios.put(
        `https://24doc.b4a.io/classes/${
          isOpenloop ? 'Openloop_Diagnosis' : 'Diagnosis'
        }/${idRef || idState}`,
        {
          ...data,
        },
        {
          headers: {
            'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
            'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
            'X-Parse-Revocable-Session': 1,
            'Content-Type': 'application/json',
          },
        }
      );
      return data2;
    } catch (err) {
      console.log('Error', err);
    }
  } else {
    toast.error('You are not authorized');
  }
};
export const LoadSpecificDiagnosis = async (id) => {
  const { data: data2 } = await axios.get(
    `https://24doc.b4a.io/classes/Diagnosis/${id}`,
    {
      params: {
        include: 'User,Service',
        keys: 'Payment,servicename,price,patient,Service.Price,Service.category,Service.title,Service.thumbnail,User,noteRequested,hasPriority',
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,

        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const LoadMedical = async (id) => {
  const { data: data2 } = await axios.get(
    `https://24doc.b4a.io/classes/Diagnosis/${id}`,
    {
      params: {
        include: 'User,Service',
        keys: 'medicalData',
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,

        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const LoadSpecificOpenloopDiagnosis = async (id) => {
  const { data: data2 } = await axios.get(
    `https://24doc.b4a.io/classes/Openloop_Diagnosis/${id}`,
    {
      params: {
        include: 'User,Service',
        keys: 'medical,User,price,weightLossModality',
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,

        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};

export const LoadMyDiagonsis = async (
  user,
  isOpenloop = false,
  limit,
  page
) => {
  const { data: data2 } = await axios.get(
    ` https://24doc.b4a.io/classes/${
      isOpenloop ? 'Openloop_Diagnosis' : 'Diagnosis'
    }`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
      params: {
        limit: limit,
        skip: limit * (page - 1),
        count: 1,
        order: '-createdAt',
        include: 'Service', // Include the full Service pointer
        where: {
          User: {
            __type: 'Pointer',
            className: '_User',
            objectId: user,
          },
          isSync: isOpenloop ? true : undefined,
        },
      },
    }
  );
  return data2;
};
export const LoadMyRefills = async (user, isOpenloop = false, limit, page) => {
  const { data: data2 } = await axios.get(
    ` https://24doc.b4a.io/classes/${
      isOpenloop ? 'Openloop_Diagnosis' : 'Diagnosis'
    }`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
      params: {
        limit: limit,
        skip: limit * (page - 1),
        count: 1,
        order: '-createdAt',

        where: {
          Service: {
            __type: 'Pointer',
            className: 'Services',
            objectId: 'W2dAN9LE3k',
          },
          User: {
            __type: 'Pointer',
            className: '_User',
            objectId: user,
          },
          isSync: isOpenloop ? true : undefined,
        },
      },
    }
  );
  return data2;
};
export const LoadMyAppointments = async (user, limit, page) => {
  const { data: data2 } = await axios.get(
    ` https://24doc.b4a.io/classes/Openloop_Diagnosis`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
      params: {
        limit: limit,
        skip: limit * (page - 1),
        count: 1,
        order: '-createdAt',

        include: 'Service', // Include the full Service pointer
        keys: 'Service.custom_form_id,Service.title,Service.origin,patient,pharmacy,medical,servicename,Payment,isBooked,Service,appt_type,weightLossModality,isUrgent,price',
        where: {
          User: {
            __type: 'Pointer',
            className: '_User',
            objectId: user,
          },
          // isSync: true,
          weightLossModality: 'sync_visit',
        },
      },
    }
  );
  return data2;
};

// All Openloop_Diagnosis consultations for a user — every subscription-based
// treatment (weight loss, ED, microdosing), sync or async, paid or unpaid.
// Used by the dashboard History page's "Subscriptions" tab, alongside the
// in-house Diagnosis list under "General Conditions". Unpaid records are
// still shown: HistoryGrid routes their "Pay Now" to the relevant
// product_recommendation page (Stripe-based) instead of the Authorize.net
// PaymentModal, since Openloop consultations are settled through a separate
// Stripe flow that pages/api/authorize/charge-accept.js knows nothing about.
export const LoadMyOpenloopHistory = async (user, limit, page) => {
  const { data: data2 } = await axios.get(
    ` https://24doc.b4a.io/classes/Openloop_Diagnosis`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
      params: {
        limit: limit,
        skip: limit * (page - 1),
        count: 1,
        order: '-createdAt',
        include: 'Service', // Include the full Service pointer (needed for thumbnail)
        where: {
          User: {
            __type: 'Pointer',
            className: '_User',
            objectId: user,
          },
        },
      },
    }
  );
  return data2;
};

export const subsription = async (data) => {
  const { status: data2 } = await axios.post(
    'https://24doc.b4a.io/classes/subscription',
    {
      ...data,
    },
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const PushNotification = async (t, userID) => {
  let typeStr = t.toString();
  const { data: data2 } = await axios.post(
    'https://24doc.b4a.io/classes/Notifications',
    {
      type: typeStr,
      userID,
      User: {
        __type: 'Pointer',
        className: '_User',
        objectId: userID,
      },
    },
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const checkNotifications = async (userID) => {
  const { data: data2 } = await axios.get(
    'https://24doc.b4a.io/classes/Notifications',
    {
      params: {
        where: {
          User: {
            __type: 'Pointer',
            className: '_User',
            objectId: userID,
          },
          seen: false,
        },
        count: 1,
        order: '-createdAt',
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const checkSubscription = async (userID) => {
  const { data: data2 } = await axios.get(
    'https://24doc.b4a.io/classes/Subscription',
    {
      params: {
        order: '-createdAt',
        limit: 1,
        where: {
          user_id: {
            __type: 'Pointer',
            className: '_User',
            objectId: userID,
          },
          active: true,
        },
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const checkSubscriptionAuthorize = async (userID) => {
  const { data: data2 } = await axios.get(
    'https://24doc.b4a.io/classes/Subscription',
    {
      params: {
        limit: 1,
        order: '-createdAt',
        where: {
          user_id: {
            __type: 'Pointer',
            className: '_User',
            objectId: userID,
          },
          active: true,
        },
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  if (data2?.results.length > 0) {
    try {
      const checkReponse = await axios.post(
        '/api/authorize/check-subscription',
        {
          subscriptionId: data2?.results[0]?.authorize_subscription_id,
        }
      );

      return { success: true, authorize_response: checkReponse.data };
    } catch (e) {
      return {
        success: false,
        error: e.message,
        message: 'Error in fetching subscription',
      };
    }
  } else {
    return {
      success: false,
      message: 'No active subscription found',
      results: data2?.results,
    };
  }
};
export const clearNotifications = async (notificationArray) => {
  const { data: data2 } = await axios.post(
    `https://24doc.b4a.io/parse/batch`,
    { requests: notificationArray },
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        // 'X-Parse-Session-Token': sessionToken,
        'Content-Type': 'application/json',
      },
    }
  );

  return data2;
};
export const getAllNotifications = async (userID) => {
  const { data: data2 } = await axios.get(
    'https://24doc.b4a.io/classes/Notifications',
    {
      params: {
        where: {
          User: {
            __type: 'Pointer',
            className: '_User',
            objectId: userID,
          },
        },

        order: '-createdAt',
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const AddError = async (
  errorObject,
  userID,
  diagnosisID,
  errorType,
  payload,
  isOL = false
) => {
  let diagnosis = {};
  if (isOL) {
    diagnosis = {
      ol_diagnosis: {
        __type: 'Pointer',
        className: 'Openloop_Diagnosis',
        objectId: diagnosisID,
      },
    };
  } else {
    diagnosis = {
      diagnosis: {
        __type: 'Pointer',
        className: 'Diagnosis',
        objectId: diagnosisID,
      },
    };
  }
  const { data: data2 } = await axios.post(
    'https://24doc.b4a.io/classes/Errors',
    {
      errorObject: errorObject,
      user: {
        __type: 'Pointer',
        className: '_User',
        objectId: userID,
      },
      ...diagnosis,
      error_type: errorType,
      payload: payload,
    },
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const AddAppointment = async (diagnosisID, userID, appointmentData) => {
  const { data: data2 } = await axios.post(
    'https://24doc.b4a.io/classes/Appointments',
    {
      userID: {
        __type: 'Pointer',
        className: '_User',
        objectId: userID,
      },
      diagnosisID: {
        __type: 'Pointer',
        className: 'Diagnosis',
        objectId: diagnosisID,
      },
      video_link: appointmentData?.external_videochat_url,
      appointment_time: appointmentData?.date,
      provider_name: appointmentData?.provider.full_name,
    },
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const AddResume = async (data) => {
  const { data: data2 } = await axios.post(
    'https://24doc.b4a.io/classes/Resumes',
    data,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const AddSearchTerm = async (term, id) => {
  const { data: data2 } = await axios.post(
    'https://24doc.b4a.io/classes/Search',
    {
      term: term,
      conditionID: {
        __type: 'Pointer',
        className: 'Services',
        objectId: id,
      },
    },
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const getPatientSubscriptions = async (userID) => {
  const { data: data2 } = await axios.get(
    'https://24doc.b4a.io/classes/Medications',
    {
      params: {
        where: {
          user_id: {
            __type: 'Pointer',
            className: '_User',
            objectId: userID,
          },
        },
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const LoadInstructions = async (id) => {
  const { data: data2 } = await axios.get(
    `https://24doc.b4a.io/classes/Instructions/${id}`,
    {
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const LoadPromotions = async (id) => {
  const { data: data2 } = await axios.get(
    `https://24doc.b4a.io/classes/Promotions`,
    {
      params: {
        where: {
          active: true,
        },
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );
  return data2;
};
export const checkIfDiscountEligible = async (user_id, promotionData) => {
  const { objectId, start_date, end_date } = promotionData;
  const { data: data2 } = await axios.get(
    `https://24doc.b4a.io/classes/Discount_Availed`,
    {
      params: {
        where: {
          user_id: {
            __type: 'Pointer',
            className: '_User',
            objectId: user_id,
          },
          // createdAt: {
          //   $gte: {
          //     __type: 'Date',
          //     iso: start_date,
          //   },
          //   // $lt: {
          //   //   __type: 'Date',
          //   //   iso: end_date,
          //   // },
          // },
          promotion_id: {
            __type: 'Pointer',
            className: 'Promotions',
            objectId: objectId,
          },
        },
      },
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,
        'X-Parse-Revocable-Session': 1,
        'Content-Type': 'application/json',
      },
    }
  );

  return data2;
};
